<template>
  <div>
    <div
      class="modal show fade modal text-left "
      style="display: block;"
      v-if="show"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              {{ confirming ? 'Unbind Device' : 'Bound Device Details' }}
            </h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="$emit('hide')"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <template v-if="confirming">
              <div class="unbind-confirm">
                <h2 class="text-danger">Are you sure to unbind this device?</h2>
                <p class="mb-0" v-if="row?.binding">
                  {{ row.binding.mobile_device_id }}
                </p>
              </div>
              <div class="d-flex justify-content-between mt-5">
                <button
                    type="button"
                    class="btn btn-secondary"
                    @click="confirming = false"
                >
                  No
                </button>
                <button
                    type="button"
                    class="btn btn-danger"
                    @click="unbindDevice"
                >
                  Yes, Unbind
                </button>
              </div>
            </template>
            <template v-else>
              <div class="card" v-if="row?.binding">
                <div class="card-body">
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <th style="width: 35%;">Mobile Device ID</th>
                        <td>{{ row.binding.mobile_device_id || '-' }}</td>
                      </tr>
                      <tr>
                        <th>Bind At</th>
                        <td>{{ row.binding.created_at ? customFormatDateTime(row.binding.created_at) : '-' }}</td>
                      </tr>
                      <tr>
                        <th>Updated At</th>
                        <td>{{ row.binding.updated_at ? customFormatDateTime(row.binding.updated_at) : '-' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-5">
                <button
                    type="button"
                    class="btn btn-danger"
                    @click="confirming = true"
                >
                  Unbind
                </button>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ["show", "row", "storageKey"],
  data() {
    return {
      confirming: false,
    };
  },
  methods: {
    unbindDevice() {
      if (!this.row) {
        return
      }

      this.$store.dispatch('exportExcelLoader', true)
      this.makeRequest("post", "v1/unbind-softpos-device", {
        posDeviceId: this.row.id
      }).then(
        callResponse => {
          this.$store.dispatch('exportExcelLoader', false)
          this.confirming = false
          if (!callResponse.error) {
            let code = callResponse.response.data.code;
            if (code == 200) {
              this.$emit('hide')
              this.$emit('refresh')
            }
          }
        }
      );
    },
  },
  watch: {
    show(val) {
      if (!val) {
        this.confirming = false
      }
    }
  }
};
</script>

<style scoped>
.modal{
  display: block !important;
}

.modal-dialog{
  overflow-y: initial !important
}
.modal-body{
  height: 70vh;
  overflow-y: auto;
}

.unbind-confirm {
  width: 100%;
  padding: 20px;
  text-align: center;
}

.unbind-confirm h2 {
  margin-bottom: 10px;
}
</style>
